function createCloudinaryUploader(config) {
  if (!config || !config.cloudName) {
    throw new Error('cloudName is required');
  }

  if (!config.uploadPreset) {
    throw new Error('uploadPreset is required');
  }

  return async function uploadImage(fileOrBlob, options) {
    options = options || {};

    var formData = new FormData();
    formData.append('file', fileOrBlob);
    formData.append('upload_preset', config.uploadPreset);

    var folder = options.folder || config.folder;
    if (folder) formData.append('folder', folder);
    if (options.public_id) formData.append('public_id', options.public_id);
    if (options.tags) formData.append('tags', options.tags);

    var response = await fetch(
      'https://api.cloudinary.com/v1_1/' + config.cloudName + '/image/upload',
      { method: 'POST', body: formData }
    );

    var text = await response.text();
    var body = null;

    try {
      body = JSON.parse(text);
    } catch (error) {
      body = null;
    }

    if (!response.ok) {
      throw new Error((body && body.error && body.error.message) || 'Upload failed (' + response.status + ')');
    }

    var secureUrl = body && body.secure_url;
    if (!secureUrl || secureUrl.indexOf('https://') !== 0) {
      throw new Error('Upload failed: invalid secure URL in response');
    }

    return {
      secureUrl: secureUrl,
      publicId: body.public_id,
      width: body.width,
      height: body.height,
      bytes: body.bytes,
      format: body.format,
      raw: body
    };
  };
}

var cloudinaryUpload = createCloudinaryUploader(window.akCloudinaryConfig || {});
